import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { SideBarIndex } from './side-bar.model';

@Component({
  selector: 'web-side-bar',
  templateUrl: './side-bar.component.html',
  styleUrls: ['./side-bar.component.scss']
})
export class SideBarComponent implements OnInit {
  TabIndex = SideBarIndex;
  @Input() indexIconBar: SideBarIndex;
  @Output() selected = new EventEmitter<number>();
  constructor(
  ) {
  }

  ngOnInit() { }

  getIndexIconBar(event: number) {
    this.selected.emit(event);
  }
}
